var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style=linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4131 2.74091L3.4812 13.2535C3.10619 13.6527 2.74327 14.439 2.67068 14.9834L2.22308 18.903C2.06582 20.3183 3.08199 21.2861 4.48528 21.0442L8.38062 20.3788C8.925 20.282 9.68716 19.8828 10.0622 19.4715L19.9941 8.95893C21.7119 7.14433 22.4861 5.07569 19.8126 2.54735C17.1512 0.0432038 15.131 0.926308 13.4131 2.74091Z",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7539 4.49512C12.2741 7.83398 14.9839 10.3865 18.3469 10.7252",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 25H22.7752",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEditIcon);
export default __webpack_public_path__ + "static/media/ProfileEditIcon.35be62daecc69f546af76c0e1e2951d4.svg";
export { ForwardRef as ReactComponent };